export default class MassiaDateController {
	/* @ngInject */
	constructor($scope, $state, $stateParams, notification, $location, $translate, SharedDataService, $attrs) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.notification = notification;
		this.$location = $location;
		this.$translate = $translate;
		this.SharedDataService = SharedDataService;
		this.$attrs = $attrs;
		this.searchText = '';
		this.name = this.$attrs.name;
		this.filteredOptions = [];
		this.messageError = '';
		this.error = false;
	}

	async $onInit() {
		this.isEditMode = false;

		if (this.ngModel === 'now') {
			this.ngModel = this.formatDate(new Date());
		}

		var dataObject = {
			value: this.ngModel,
			messageType: '',
			message: ''
		};

		this.SharedDataService.setData(this.name, dataObject);

		this.$scope.$watch(
			() => this.ngModel,
			(newValue, oldValue) => {
				console.log(newValue);
				if (newValue !== oldValue) {
					var dataObject = {
						value: this.ngModel,
						messageType: '',
						message: ''
					};

					this.SharedDataService.setData(this.name, dataObject);
				}
			}
		);

		// Écoute des changements spécifiques via SharedDataService
		this.SharedDataService.listenData(this.name, this.verifyForm.bind(this));
	}

	async verifyForm(newValueObject) {
		this.error = false;
		if (newValueObject.messageType === 'error') {
			this.error = true;
			this.messageError = newValueObject.message;
		}
	}

	formatDate(date) {
		const pad = (n) => (n < 10 ? '0' + n : n);
		const day = pad(date.getDate());
		const month = pad(date.getMonth() + 1);
		const year = date.getFullYear();
		return `${day}/${month}/${year}`;
	}

	$onDestroy() {
		// Nettoyage si nécessaire
	}

	reset() {
		this.ngModel = 0;
		this.searchText = '';
		this.options = [];
	}

	onFocus() {
		this.isFocused = true;
	}
}
